import {useAccountUser} from "@twigsby/client-data";
import {BasicContent, FlexAlign, FlexGap, FlexJustify, StackVertical, useLayout} from "@twigsby/frontend-framework";
import React, {forwardRef, useRef} from "react";
import StandaloneSendForm from "../../Components/SendsAdmin/StandaloneSendForm";
import StandaloneSendTemplateNavigation from "../../Components/SendsAdmin/StandaloneSendTemplateNavigation";
import SendMailProvider from "../../Providers/SendMailProvider";
import UserPageHeader from "../../Components/SendsUser/UserPageHeader";
import UserPageFooter from "../../Components/SendsUser/UserPageFooter";
import {useParams} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPaperPlane} from "@fortawesome/pro-solid-svg-icons/faPaperPlane";

const UserSendsPageContent = forwardRef((props, ref) => {
    const { isMedium } = useLayout();

    return (
        <div className={`row ${!isMedium ? 'pl-sm pr-sm' : 'mt-sm'} mb-xl`}>
            <div className={'col-xs-12 col-center-md-8 col-center-lg-10 col-center-xxl-8'}>
                <div className='row no-gap'>
                    <div className='col-xs-12 col-lg-3 col-xl-3'>
                        <StandaloneSendTemplateNavigation containerRef={ref} />
                    </div>

                    <div className='col-xs-12 col-lg-9 col-xl-6'>
                        <StandaloneSendForm />
                    </div>
                </div>
            </div>
        </div>
    )
})

const UserSendsPage = () => {
    const { pageId } = useParams();
    const { data } = useAccountUser();
    const containerRef = useRef<any>(null);

    return (
        <BasicContent ref={containerRef}>
            {(pageId ||
                    !pageId && data?.roles.includes('SENDS_PAGE_ADMIN') ||
                    !pageId && data?.roles.includes('MANAGER'))
                && (
                    <SendMailProvider>
                        <UserPageHeader />
                        <UserSendsPageContent ref={containerRef} />
                        <UserPageFooter />
                    </SendMailProvider>
            )}

            {!pageId && (!data?.roles.includes('SENDS_PAGE_ADMIN') && !data?.roles.includes('MANAGER')) && (
                <div style={{ borderRadius: 'var(--border-radius)', display: 'flex', background: 'var(--secondary-bg)', height: '53.5em', alignItems: 'center', justifyContent: 'center'}}>
                    <StackVertical gap={FlexGap.ExtraSmall} align={FlexAlign.Center} justify={FlexJustify.Center} extraClass={'m-xxl p-xxl text-center'}>
                        <FontAwesomeIcon icon={faPaperPlane} size={"3x"} />
                        <h6 className={'sub-heading mt-sm mb-xs'}>No Pages</h6>
                        <p>You haven't been given access to any pages yet</p>
                    </StackVertical>
                </div>
            )}

        </BasicContent>
    )
}

export default UserSendsPage

export { UserSendsPageContent }
